// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The hero treatment comes from the shared .page-hero rule in AboutUs.css —
   this page used to re-declare the dark version, which would now override the
   lightened base. */
.faq-list {
  display: grid;
  gap: 20px;
  max-width: 860px;
}

.faq-item {
  background-color: var(--surface-raised);
  border-radius: var(--radius-md);
  padding: 28px;
  box-shadow: var(--shadow-soft);
}

.faq-item h3 {
  margin-bottom: 10px;
}

.faq-item p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FAQ.css"],"names":[],"mappings":"AAAA;;oBAEoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/* The hero treatment comes from the shared .page-hero rule in AboutUs.css —\n   this page used to re-declare the dark version, which would now override the\n   lightened base. */\n.faq-list {\n  display: grid;\n  gap: 20px;\n  max-width: 860px;\n}\n\n.faq-item {\n  background-color: var(--surface-raised);\n  border-radius: var(--radius-md);\n  padding: 28px;\n  box-shadow: var(--shadow-soft);\n}\n\n.faq-item h3 {\n  margin-bottom: 10px;\n}\n\n.faq-item p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
